import React,{useRef} from "react";
import { useField, useFormikContext } from "formik";
import ReCAPTCHA from "react-google-recaptcha";

const FormikRecaptcha = ({ ...props }) => {
  const { setFieldValue } = useFormikContext();
  const [field,meta] = useField(props);
  const captchaRef = useRef(null)
  return (
    <div className="field-container">
      <div className="error-container"><em>*</em>{meta.touched && meta.error && <div className="error">{meta.error}</div>}</div>
    <ReCAPTCHA
      {...field}
      {...props}
      ref={captchaRef}
      onChange={() => { setFieldValue("captcha", captchaRef.current.getValue()); }}
      sitekey='6LfU3gokAAAAALqYgCrFUSBcrQmRHRTj_M5uv8NU' 
    />
    </div>
  );
};

export default FormikRecaptcha;